module.exports = __webpack_public_path__ + "assets/cf9f0b2b53024ca586da6c3e8a957d01.svg";